__turbopack_context__.v({
  "moneyBlocksWrapper": "HXziCW_moneyBlocksWrapper",
});
